import React from "react";
import styled from "styled-components";

const IconButton = styled.button`
  background: ${props =>
    props.secondary ? props.theme.buttonSecondary : props.theme.buttonPrimary};
  border: 1px solid
    ${props =>
      props.secondary
        ? props.theme.buttonSecondary
        : props.theme.buttonPrimary}};

  color: ${props => props.theme.white};
  border-radius: 33px;
  cursor: pointer;
  outline: none;
  width: 100%;
  height: 100%;
`;

export default IconButton;
